import React from 'react'
import {Link} from '@reach/router'
import styled from 'styled-components'

const SidebarContainer = styled.div`
    float: left;
    padding: 2rem 1rem 3rem;
    width:  250px;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    header {
        font-weight: bold;
        text-transform: uppercase;
        margin: 0 0 8px 0;
    }
    ul {
        margin: 0 0 16px 0;
        list-style-type: none;

    }
`

export const Sidebar = ({section}) => (

  <SidebarContainer className="d-lg-block" style={{overflowY : `auto`}}>
    <Link to="/docs/guide" style={{color:`grey`, fontWeight:`bold`}}>eNETS Integration Guide</Link>
    <ul>
        <li>
            {(section  === 'overview') ? (
                <Link to="/docs/guide" ><b style={{color:`grey`}}>- Overview</b></Link>
            ) : (
                <Link to="/docs/overview" >+ Overview</Link>
            )}
            {(section  === 'overview') ? (
            <ul style={{ paddingLeft: "1rem"}}>
                <li><a href="#hardware--software-compatibility">Hardware & Software Compatibility</a></li>
                <li><a href="#terms--conditions">Terms & Conditions</a></li>
                <li><a href="#getting-started">Getting Started</a></li>
                <li><a href="#pre-production">Pre-Production</a></li>
                <li><a href="#api-installation-and-setup">API Installation and Set-Up</a></li>
                <li><a href="#mobile-sdk-setup">Mobile SDK Set-Up</a></li>
                <li><a href="#key-concepts">Key Concepts</a></li>
                <li><a href="#applicable-usage">Applicable Usage</a></li>
                <li><a href="#source-of-funds-versus-transaction-flows">Source of Funds versus Transaction Flows</a></li>
                <li><a href="#document-change-log">Document Change Log</a></li>
            </ul> )
            : null }
        </li>
        <li>
            {(section  === 'web') ? (
                <Link to="/docs/guide"><b style={{color:`grey`}}>- Web</b></Link>
            ) : (
                <Link to="/docs/web">+ Web</Link>
            )}
            {(section  === 'web') ? (
            <ul style={{ paddingLeft: "1rem"}}>
                <li><a href="#integration-via-plugins">Integration Via Plugins</a></li>
                <li><a href="#flow-1-web-browser">Flow 1 (Web Browser)</a></li>
                <ul style={{ paddingLeft: "1rem"}}>
                    <li><a href="#sequence-diagram">Sequence Diagram</a></li>
                    <li><a href="#required-steps">Required Steps</a></li>
                    <li><a href="#sample-request">Sample Request</a></li>
                    <li><a href="#calculating-mac-value">Calculating MAC Value</a></li>
                    <li><a href="#sending-the-request">Sending the Request</a></li>
                    <li><a href="#response-processing">Response Processing</a></li>
                </ul>
                <li><a href="#flow-3-qr">Flow 3 (QR)</a></li>
                <ul style={{ paddingLeft: "1rem"}}>
                    <li><a href="#sequence-diagram-1">Sequence Diagram</a></li>
                    <li><a href="#required-steps-1">Required Steps</a></li>
                    <li><a href="#sample-request-1">Sample Request</a></li>
                    <li><a href="#calculating-mac-value-1">Calculating MAC Value</a></li>
                    <li><a href="#sending-the-request-1">Sending the Request</a></li>
                    <li><a href="#qr-flow">QR Flow</a></li>
                    <li><a href="#response-processing">Response Processing</a></li>
                </ul>
            </ul> )
            : null}
        </li>
        <li>
            {(section  === 'ios') ? (
                <Link to="/docs/guide"><b style={{color:`grey`}}>- iOS</b></Link>
            ):(
                <Link to="/docs/ios">+ iOS</Link>
            )}

            {(section  === 'ios') ? (
                <ul style={{ paddingLeft: "1rem"}}>
                    <li><a href="#sdk-download">SDK Download</a></li>
                    <li><a href="#sdk-setup">SDK Set-Up</a></li>
                    <li><a href="#flow-2-mobile-native-app">Flow 2 (Mobile Native App)</a></li>
                    <ul style={{ paddingLeft: "1rem"}}>
                        <li><a href="#sequence-diagram">Sequence Diagram</a></li>
                        <li><a href="#request-preparation">Request Preparation</a></li>
                        <li><a href="#calculating-mac-value">Calculating MAC Value</a></li>
                        <li><a href="#sdk-integration">SDK Integration</a></li>
                        <li><a href="#response-handling">Response Handling</a></li>
                    </ul>
                </ul>

            ) : null }
        </li>
        <li>
            {(section  === 'android') ? (
                <Link to="/docs/guide"><b style={{color:`grey`}}>- Android</b></Link>
            ) :(
                <Link to="/docs/android">+ Android</Link>
            )}

            {(section  === 'android') ? (
                <ul style={{ paddingLeft: "1rem"}}>
                    <li><a href="#sdk-download">SDK Download</a></li>
                    <li><a href="#sdk-setup">SDK Set-Up</a></li>
                    <li><a href="#flow-2-mobile-native-app">Flow 2 (Mobile Native App)</a></li>
                    <ul style={{ paddingLeft: "1rem"}}>
                        <li><a href="#sequence-diagram">Sequence Diagram</a></li>
                        <li><a href="#request-preparation">Request Preparation</a></li>
                        <li><a href="#calculating-mac-value">Calculating MAC Value</a></li>
                        <li><a href="#sdk-integration">SDK Integration</a></li>
                        <li><a href="#response-handling">Response Handling</a></li>
                    </ul>
                </ul>

            ) : null }
        </li>
        <li>
            {(section  === 'others') ? (
                <Link to="/docs/guide"><b style={{color:`grey`}}>- Others</b></Link>
            ) :(
                <Link to="/docs/others">+ Others</Link>
            )}
            {(section  === 'others') ? (
                <ul style={{ paddingLeft: "1rem"}}>
                    <li><a href="#flow-4-server-to-server">Flow 4 (Server-to-Server)</a></li>
                    <ul style={{ paddingLeft: "1rem"}}>
                        <li><a href="#sequence-diagram">Sequence Diagram</a></li>
                        <li><a href="#required-steps">Required Steps</a></li>
                        <li><a href="#sample-request">Sample Request</a></li>
                        <li><a href="#calculating-mac-value">Calculating MAC Value</a></li>
                        <li><a href="#response-format">Response Format</a></li>
                        <li><a href="#sample-3d-redirection">Sample 3D Redirection</a></li>
                        <li><a href="#response-handling">Response Handling</a></li>
                    </ul>

                    <li><a href="#transaction-query">Transaction Query</a></li>
                    <ul style={{ paddingLeft: "1rem"}}>
                        <li><a href="#overview">Overview</a></li>
                        <li><a href="#message-format">Message Format</a></li>
                        <li><a href="#recurring-payment">Recurring Payment</a></li>
                        <li><a href="#ipp-payment">IPP Payment</a></li>
                        <li><a href="#card-prefix">Card Prefix</a></li>
                    </ul>

                    <li><a href="#faq--exception-handling">FAQ & Exception Handling</a></li>
                    <li><a href="#api---definitions">API - Definitions</a></li>
                    <li><a href="#api---message-format">API - Message Format</a></li>
                    <li><a href="#api---response--action-codes">API - Response & Action Codes</a></li>

                </ul>

            ) : null }
        </li>
    </ul>
    <ul>
        <li>
            <Link to="/docs/qr" style={{color:`grey`, fontWeight:`bold`}}>NETS QR Integration Guide</Link>
        </li>
        <li>
            <Link to="/docs/netspay" style={{color:`grey`, fontWeight:`bold`}}>NETSPay In-App Integration Guide</Link>
        </li>
    </ul>
  </SidebarContainer>
)


export const RefBar = ({section}) => (

    <SidebarContainer className="d-lg-block" style={{overflowY : `auto`}}>
        <header style={{color:`grey`, fontWeight:`bold`}}>eNETS API</header>
        <ul style={{ paddingLeft: "1rem"}}>
            <li>
                <a href="/docs/api/">eNETS Demo</a>
            </li>
            <li>
                <a href="#txnqueryreq">TxnQueryReq</a>
            </li>
            <li>
                <a href="#txnqueryres">TxnQueryRes</a>
            </li>
            <li><a href="#recurring-payment">Recurring Payment</a></li>
            

            <li><a href="#ipp-payment">IPP Payment</a></li>
            

            <li><a href="#card-prefix">Card Prefix</a></li>
            
            
        </ul>
        <header style={{color:`grey`, fontWeight:`bold`}}>NETS QR</header>
        <ul style={{ paddingLeft: "1rem"}}>

            <li>
                <a href="/docs/api-qr/">NETS QR Demo</a>
            </li>

            <li><a href="#order">Order</a></li>
            

            <li><a href="#transaction-query">Transaction Query</a></li>
            

            <li><a href="#response-codes-from-api-gateway">Response Codes from API Gateway</a></li>

            <li><a href="#order-reversal">Order Reversal</a></li>

            <li><a href="#communication-data">Communication Data</a></li>

            <li><a href="#npx-data">NPX Data</a></li>

        </ul>
        <header style={{color:`grey`, fontWeight:`bold`}}>API</header>
        <ul style={{ paddingLeft: "1rem"}}>
            <li>
                <a href="#definitions">Definitions</a>
            </li>   
            <li><a href="#message-format">Message Format</a></li>
            <li>
                <a href="#action-codes">Action Codes</a>
            </li>
            <li>
                <a href="#response-codes">Response Codes</a>
            </li>
        </ul>
    </SidebarContainer>
)



export const ResBar = ({section}) => (

    <SidebarContainer className="d-none d-lg-block" style={{overflowY : `auto`}}>
        <header style={{color:`grey`, fontWeight:`bold`}}>
            Resources
        </header>
        <ul style={{ paddingLeft: "1rem"}}>
            <li>
                <a href="#common-test-credentials">Common Test Credentials</a>
            </li>
            <li>
                <a href="#test-credit-card-details">Test Credit Card Details</a>
            </li>
        </ul>
        <header style={{color:`grey`, fontWeight:`bold`}}>
            Other Resources
        </header>
        <ul style={{ paddingLeft: "1rem"}}>
            <li>
                <a href="#enets">eNETS</a>
            </li>
            <li>
                <a href="#enets-service-change-request-form">eNETS Service Change Request Form</a>
            </li>
            <li>
                <a href="#netspay">NETSPay</a>
            </li>
            <li>
                <a href="#certification">Certification</a>
            </li>
        </ul>
    </SidebarContainer>
)
